export default function lowercase(value) {
  const lowercase = /[a-z]/;
  if (!lowercase.test(value)) {
    return 'lowercase';
  }

  return null;
}
